import { lazy } from 'react';

const DashBoardCardView = lazy(() => import('./CardView'));
export { DashBoardCardView };
